import { ColumnProps } from "antd/lib/table";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import UnitPartitionContext from "../../../context/unit-partition/context";
import { IUnitPartition } from "../../../models/unit-partition/response";
import Space from "../../general/antd/space";
import ViewBtn from "../../general/table-components/actions/view-btn";
import EditBtn from "../../general/table-components/actions/edit-btn";
import DeleteBtn from "../../general/table-components/actions/delete-btn";
import eventManager, { EVENT_SUCCESS } from "../../../utils/events";
import { ISort, IStaticFilter } from "../../../models/base/base-query";
import { tableOnChange } from "../../../utils/helpers/table-sorts-filters";
import Table from "../../general/table-components/table";
import styles from './styles.module.scss';
const UnitPartitionTable: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { list, actions, loading, query } = useContext(UnitPartitionContext);

  const columns: ColumnProps<IUnitPartition>[] = [
    {
      title: t("id"),
      dataIndex: "id",
      key: "id",
      sorter: { multiple: 1 },
      width: 100,
      align: "center",
    },
    {
      title: t("name"),
      dataIndex: "name",
      align: "center",
      key: "name",
      sorter: { multiple: 2 },
    },
    {
      title: t("unitName"),
      width: 250,
      dataIndex: "",
      align: "center",
      key: "x",
      render: (_, record) => (
        record.unit.name
      )
    },
    {
      title: t("actions"),
      width: 250,
      dataIndex: "",
      align: "center",
      key: "x",
      render: (_, record) => (
        <Space>
          <ViewBtn
            onClick={(e) => {
              const url = `/unit-partitions/details/${record?.id}`;
              if (e.ctrlKey || e.metaKey) {
                window.open(url, "_blank");
              } else {
                navigate(url);
              }
            }}
          />
          <EditBtn
            onClick={(e) => {
              const url = `/unit-partitions/update/${record?.id}`;
              if (e.ctrlKey || e.metaKey) {
                window.open(url, "_blank");
              } else {
                navigate(url);
              }
            }}
          />
          <DeleteBtn
            onConfirm={async () => {
              await actions.deleteUnitPartition(record?.id);
              eventManager.emit(EVENT_SUCCESS);
            }}
            loading={loading.includes("delete")}
          />
        </Space>
      ),
    },
  ];

  const [sorts, setSorts] = useState<ISort[]>([]);
  const [, setStaticFilters] = useState<IStaticFilter[]>(query?.filters ?? []);

  useEffect(() => {
    if (sorts.length > 0) {
      actions.setQuery({ ...query, orders: sorts });
    }
  }, [sorts]);

  return (
    <Table
      rowKey="id"
      showPagination
      columns={columns}
      className={styles.table}
      dataSource={list?.data ?? []}
      loading={loading.includes("list") || list == undefined}
      size="small"
      total={list?.total}
      pageSize={query.perPage}
      page={query.page}
      onPaginationChange={(page, pageSize) => {
        actions.setQuery({ ...query, page, perPage: pageSize });
      }}
      onChange={(_, tableFilters, tableSorters) => {
        tableOnChange(tableFilters, tableSorters, {}, setSorts, setStaticFilters);
      }}
    />
  );
};

export default UnitPartitionTable;
